import { render, staticRenderFns } from "./fareManage.vue?vue&type=template&id=60068517&scoped=true"
import script from "./fareManage.vue?vue&type=script&lang=js"
export * from "./fareManage.vue?vue&type=script&lang=js"
import style0 from "./fareManage.vue?vue&type=style&index=0&id=60068517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60068517",
  null
  
)

export default component.exports